export const auditTypeMasterColumnData = [
    {
      label: "Audit Type",
      excelName: "Audit Type",
      isSort: true,
      id: "name",
      isIcon: false,
    },
    {
      label: "Unique Prefix",
      excelName: "Unique Prefix",
      isSort: true,
      id: "abbreviation",
      isIcon: false,
    },
    {
      label: "Action",
      isSort: false,
      columnWidth: '150px',
      id: "ActionToEditAndDelete",
      isIcon: true,
      cellAlign: "center",
      headerAlign: "center",
    },
  ];


  // Excel Download - Columns
export const sampleActivityColumnFormat = [
  {
    label: "Activity",
    excelName: "Activity",
    excelDataField: "name",
    id: "name",
  },
]

// Excel Download - Data
export const sampleActivityDataFormat =  [
  {
    name: "Conducting risk assessment for financial transactions.",
  },
]